import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  HStack,
  Text,
  Heading,
} from '@chakra-ui/react';

interface IDeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: IDeleteConfirmationModalProps): JSX.Element => (
  <Modal size="lg" scrollBehavior="inside" isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        <Heading size="lg" fontWeight="normal">
          Confirmar exclusão
        </Heading>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>Deseja realmente excluir?</Text>
      </ModalBody>

      <ModalFooter>
        <HStack>
          <Button colorScheme="blackAlpha" onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="red" onClick={onConfirm}>
            Excluir
          </Button>
        </HStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
